import styled from 'styled-components';
import {
  FONT_FAMILY_MAIN,
  MAIN_BLUE,
  PALE_CORNFLOWER_BLUE,
  SILVER,
  ZIRCON,
} from '@espacePro/constants/admin-theme';

const HollowButton = styled.button`
  border-radius: 6px;
  border: solid 1px ${PALE_CORNFLOWER_BLUE};
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 12px;
  font-weight: bold;
  line-height: 1.17;
  color: ${MAIN_BLUE};
  padding: 7px 8px;
  text-decoration: none;
  transition: border-color .3s ease;
  cursor: pointer;
  appearance: none;
  background: #fff;
  
  &:hover,
  &:focus {
    border-color: ${(props) => (props.disabled ? 'none' : MAIN_BLUE)};
  }
  
  &:disabled {
    cursor: not-allowed;
    border-color: ${ZIRCON};
    color: ${SILVER};
  }
`;

export { HollowButton };
